import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFolderUpload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolderUpload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '660f7e8585302a7d4eb6ce20b50d449f7c0f2301', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5c8a957b53bbe0d81ca794fddbe15623adec6b3d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cedb6cc25bb4b3b67f4be97801befada9c568765', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 6h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h4.5v-9h-7.19a.5.5 0 0 1-.44-.28L10 5.5H3.5V9a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 2 9V4.5a.5.5 0 0 1 .5-.5h8.14a.5.5 0 0 1 .49.28zm0 9a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.3-2.83-2 2.15A.4.4 0 0 0 5 15h1.25v2.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V15H9a.4.4 0 0 0 .27-.68l-2-2.15a.4.4 0 0 0-.57 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-folder-upload", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder-upload"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder-upload":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolderUpload$1);
            }
            break;
    } });
}

const CosmosIconFolderUpload = CosmosIconFolderUpload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolderUpload, defineCustomElement };
